<template>
    <div v-click-outside="handleClick" :class="{ open: isOpen }" class="vue-search-bar">
        <button
            @click="handleClick"
            :aria-expanded="isOpen ? 'true' : 'false'"
            aria-controls="search-bar"
            class="menu-toggle crossed"
        >
            <span class="bars"></span>
            <span class="text">
                    {{ translations.closeText }}
                </span>
        </button>

        <div class="inner">
            <label for="search-bar" class="visually-hidden">{{ translations.searchText }}</label>
            <input id="search-bar" type="search" @keyup.enter="handleSearch" v-model="value" :placeholder="translations.searchPlaceholder" ref="searchBar">

            <button @click="handleSearch" type="submit">
                {{ translations.searchText }}
            </button>
        </div>
    </div>
</template>

<script>
import translations from "../mixins/translations";
import ClickOutside from 'vue-click-outside';

export default {
    name: "SearchBar",

    mixins: [translations],

    directives: {
        ClickOutside
    },

    props: ['isOpen'],

    data() {
        return {
            open: this.isOpen,
            value: '',
        }
    },

    methods: {
        handleClick() {
            this.open = false;

            this.$emit('toggle-search-bar', false);
        },

        handleSearch() {
            if (lodash.isEmpty(this.value)) {
                return;
            }

            window.location = `/zoeken?search=${this.value}`;
        },

        handleFocusInput() {
            setTimeout(() => {
                this.$refs.searchBar.focus();
            }, 300);
        }
    },

    mounted() {
        this.popupItem = document.querySelector('#page-wrapper > header');
    },

    watch: {
        isOpen(val) {
            this.open = val;

            if (!this.open) {
                return;
            }

            this.handleFocusInput();
        },
    },
}
</script>
